import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { OperationsStationsGridView } from '../../features/operations-stations-grid/operations-stations-grid-view';

export const Route = createFileRoute('/operations-stations-grid/')({
  component: OperationsStationsGridPage,
});

function OperationsStationsGridPage() {
  const partnerId = usePartnerId();

  return <OperationsStationsGridView partnerId={partnerId} />;
}
